import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class ImageCounter extends PureComponent {
    static propTypes = {
        index: PropTypes.number.isRequired,
        nOfSlides: PropTypes.number.isRequired,
    };

    render() {
        return (
            <div className="lightbox-imagecounter u-milk u-t4 u-pv16 u-display-inline-block">
                {this.props.index} av {this.props.nOfSlides}
            </div>
        );
    }
}
